<template>
  <div
    v-if="
      book &&
      (!userSettings.settings.showPagePreview ||
        userSettings.settings.showPagePreview == 'on')
    "
    v-zindex
    v-body
    ref="container"
    class="header-container"
    :style="{ width: previewPageSize }"
  >
    <headerItem
      :currentHeaderData="currentHeaderData"
      :book="book"
      :full="
        full ||
        !userSettings.settings.pagePreviewType ||
        userSettings.settings.pagePreviewType == 'full'
      "
      @setHeight="setHeight"
      @setLocation="setHeaderLocation"
      :byPos="byPos"
    />
  </div>
</template>

<script>
import headerItem from "./headerItem.vue";
import Vue from "vue";
export default {
  data() {
    return {
      img: "",
      headerTop: 0,
      headerLeft: 0,
      timer: null,
    };
  },
  props: [
    "currentHeaderData",
    "book",
    "single",
    "thumbnaleWidth",
    "full",
    "byPos",
  ],
  components: { headerItem },
  mounted() {
    this.setHeaderLocation();
  },
  watch: {
    currentHeaderData: function (val) {
      this.setHeaderLocation();
    },
  },
  computed: {
    previewPageSize() {
      return this.thumbnaleWidth
        ? this.thumbnaleWidth + "px"
        : this.userSettings.settings.pagePreviewSize == "big"
        ? "600px"
        : this.userSettings.settings.pagePreviewSize == "medium" ||
          !this.userSettings.settings.pagePreviewSize
        ? "400px"
        : "200px";
    },
  },
  methods: {
    setHeight(val) {
      this.$refs.container.style.height = val + "px";
    },
    setHeaderLocation() {
      if (!this.$refs.container) return;

      this.$refs.container.style.top = this.currentHeaderData.top + "px";

      if (
        this.currentHeaderData.top + this.$refs.container.clientHeight >
        window.innerHeight
      ) {
        this.$refs.container.style.top =
          this.$refs.container.offsetTop -
          (this.currentHeaderData.top +
            this.$refs.container.clientHeight -
            window.innerHeight) -
          10 +
          "px";
      }
      this.$refs.container.style.left =
        this.currentHeaderData.left - this.$refs.container.offsetWidth + "px";
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  text-align: right;
}
.header-container {
  width: 704px;

  //border: 1px solid black;
  position: absolute;
  padding: 1px;
  webkit-box-shadow: 2px 2px 13px 3px rgb(0 0 0 / 75%);
  box-shadow: 2px 2px 13px 3px rgb(0 0 0 / 75%);
}
</style>
